// SYSTEM_ROUTE: /direction/roles
import { DirectionLensView } from './DirectionLensView.js';

export function DirectionRolesScreen() {
  return (
    <DirectionLensView
      lens="roles"
      title="Roles & Relationships"
      subtitle="Son, founder, learner, friend — the contexts you act from, with the care and duties they carry. Context, never a scoreboard."
      placeholder="Name a role you hold…"
    />
  );
}
